module.exports = __webpack_public_path__ + "files/ae12d61d9c78c952f54d3856f63691fd.svg";